import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { component } from "picoapp";
import { ReactDrawer } from "../parts";
import { useMount } from "ahooks";
import { motion, AnimatePresence } from "framer-motion";
import classnames from "classnames";
import { slugify } from "@utils";

const MenuItem = ({ link, level, showImage, path }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [insert, setInsert] = useState();
  const [img, setImg] = useState();
  const optionClasses = classnames(
    "Nav__item",
    `level-${level}`,
    {
      "is-active": link.active,
    },
    slugify(link.title)
  );

  useEffect(() => {
    if (link.links && level < 2) {
      setIsOpen(!isOpen);
    }
    let el = document.querySelector(
      `.Header__navigation .Nav__item.${link.title
        .toLowerCase()
        .replace(/ /g, "-")
        .replace("?", "")} .Nav__item--product-quantity`
    );
    let text;
    el ? (text = el.textContent) : null;
    let collImg = document.querySelector(
      `.Header__navigation .Nav__item.${link.title
        .toLowerCase()
        .replace(/ /g, "-")
        .replace("?", "")} img`
    );
    let src;
    collImg ? (src = collImg.src) : null;
    setImg(src);
    setInsert(text);
  }, []);

  return (
    <div className={optionClasses}>
      <motion.a
        initial={false}
        href={link.url}
        className={`Nav__link level-${level}`}
      >
        {showImage &&
          img &&
          level >= 2 &&
          link.title != "Shop All" &&
          link.title != "On Sale" && (
            <figure>
              <img src={img} alt={link.title} loading="lazy" />
            </figure>
          )}
        <div className="Nav__item--text-wrapper">
          <span>{link.title}</span>
          {insert &&
            (link.title === "Meals" ||
              link.title === "Fruits" ||
              link.title === "Veggies" ||
              link.title === "Meats" ||
              link.title === "Cheeses" ||
              link.title === "Bulk") && (
              <div className="Nav__item--product-quantity">{insert}</div>
            )}
        </div>
        {link.title === "Shop All" && <div className="shopAll--arrow"></div>}
      </motion.a>
      {link.links && (
        <AnimatePresence initial={false}>
          {isOpen && (
            <motion.div
              key="content"
              initial="collapsed"
              animate="open"
              exit="collapsed"
              variants={{
                open: { opacity: 1, height: "auto" },
                collapsed: { opacity: 0, height: 0 },
              }}
              transition={{ duration: 0.6, ease: [0.04, 0.62, 0.23, 0.98] }}
            >
              {level < 2 && (
                <SubMenu
                  items={link.links}
                  parent={link}
                  level={level}
                  showImage={showImage}
                  path={path}
                ></SubMenu>
              )}
            </motion.div>
          )}
        </AnimatePresence>
      )}
    </div>
  );
};

const SubMenu = ({ items, level, parent, showImage, path }) => {
  useEffect(() => {
    console.log("submenu", path);
  }, []);
  return (
    <div
      className={`Nav__submenu level-${level}`}
      data-identifier={parent.object_handle}
    >
      {items.map((link, index) => {
        return (
          <MenuItem
            link={link}
            level={level + 1}
            key={link.title}
            showImage={showImage}
            path={`${path}_${slugify(link.title)}`}
          ></MenuItem>
        );
      })}
    </div>
  );
};

const MobileNav = ({ parentNode }) => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [mainMenu, setMainMenu] = useState({ title: "", links: [] });
  const [customer, setCustomer] = useState();

  useMount(() => {
    let contentTag = parentNode.nextElementSibling;
    try {
      let menuData = JSON.parse(contentTag.innerText);

      // main menu
      let menuKey = Object.keys(menuData["main"])[0];
      setMainMenu(menuData["main"][menuKey]);

      // customer
      // setCustomer(menuData['customer']);
    } catch (error) {
      console.log(error);
    }
  });

  const { links } = mainMenu;

  return (
    <>
      <button
        className="Button mobile-toggler"
        data-layout="noLayout"
        onClick={() => setShowDrawer(!showDrawer)}
      >
        <svg
          className="icon icon--primary"
          height="1em"
          viewBox="0 0 20 20"
          width="1em"
          role="presentation"
        >
          <use xlinkHref="#menu"></use>
        </svg>
        <span className="screen-reader-text">Menu</span>
      </button>
      <a href="/account" className="Button" data-layout="noLayout">
        <svg
          viewBox="0 0 20 20"
          className="icon icon--primary"
          width="1em"
          height="1em"
          role="presentation"
        >
          <use href="#user"></use>
        </svg>
        <span className="screen-reader-text">Account</span>
      </a>
      <ReactDrawer
        className="mobileNav"
        showDrawer={showDrawer}
        setShowDrawer={setShowDrawer}
        position={"left"}
      >
        <div className="Nav Nav--mainMobile Nav--vertical">
          <div
            className="close-icon"
            onClick={() => setShowDrawer(false)}
          ></div>
          {links.map((link, index) => {
            console.log(link);
            return (
              <MenuItem
                link={link}
                level={1}
                key={link.title}
                showImage={true}
                path={
                  link.title === "Shop"
                    ? link.title.toLowerCase()
                    : link.object_handle
                }
              ></MenuItem>
            );
          })}
        </div>
        {/* <div className="Nav Nav--account Nav--vertical">
          {customer ? (
            <>
              <div className="Nav__item">Hello {customer}</div>
              <a href="/account" className="Menu__item">
                My Account
              </a>
              <a href="/account/logout" className="Menu__item">
                Logout
              </a>
            </>
          ) : (
            <a href="/account/login" className="Menu__item">
              Login
            </a>
          )}
        </div> */}
      </ReactDrawer>
    </>
  );
};

export default component((node, ctx) => {
  const element = <MobileNav ctx={ctx} parentNode={node} />;
  ReactDOM.render(element, node);
});
